import type { ReactNode } from 'react';

export function Header({ children }: { children: ReactNode }) {
  return (
    <header className="ml--header bg-white px-3">
      <div className="relative flex flex-col gap-3 py-3 mx-auto max-w-screen-xl">{children}</div>
    </header>
  );
}
